{
  "#LAGERSTAND": {
    "APP": "Lagerstand",
    "APP_DESC": "Abfrage von Lagerstand und Lagerplatz eines Artikels",
    "TITLE": "Lagerstand",
    "PAGES": {
      "ARTIKEL_EINGABE": {
        "TITLE": "Artikel eingeben",
        "DESCRIPTION": "oder scannen",
        "ARTIKEL": "Artikel"
      },
      "ERGEBNIS": {
        "TITLE": "Lagerstand",
        "DESCRIPTION": "Lagerplatz und Mengen",
        "LAGERPLATZ": "Lagerplatz",
        "ARTIKEL": "Artikel"
      }
    }
  }
}
